export default {"src":"/_next/static/media/skipping.colour.8fab7b16.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};